function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPageNotFound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 750 500",
    style: {
      enableBackground: "new 0 0 750 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Background_Simple"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9"
    },
    d: "M704.185,191.603c-7.88-28.378-60.413,2.488-60.413,2.488l13.747-24.936 c1.633-2.472,3.099-5.092,4.354-7.899c6.904-15.439,6.813-31.954-0.036-46.337c-1.883-8.732-7.586-21.212-23.319-34.889 C608.75,54.152,508.938,36.451,480.045,40.381c-28.893,3.931,26.266,16.086,26.266,16.086l-4.372-0.038 c-84.153-8.922-168.824-10.07-252.833-8.331c-21.066,0.436-42.196,1.127-62.822,4.686c-5.935,1.024-12.317,2.588-15.85,7.375 c-15.683,21.266,48.469,23.344,58.532,22.934c-44.063,5.727-93.023,7.483-134.002,24.512c-5.718,2.376-11.382,5.192-15.69,9.588 s-7.115,10.633-6.144,16.901c2.819,18.197,27.89,23.591,42.106,27.632c0,0-81.72,54.339-72.089,81.922 c3.981,11.402,9.915,23.405,20.912,35.221c-6.268,7.869-11.787,16.126-16.053,24.856c-2.61,5.34-6.029,12.656-3.108,18.803 c14.884,31.325,240.613,138.856,421.495,108.165c48.051-8.153,95.907-21.635,138.031-45.479 c41.919-23.729,84.636-62.924,95.196-112.348c0.348-1.629,0.603-3.208,0.777-4.744 C706.95,245.345,710.777,215.344,704.185,191.603z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.8,
      fill: "#FFFFFF"
    },
    d: "M704.185,191.603c-7.88-28.378-60.413,2.488-60.413,2.488l13.747-24.936 c1.633-2.472,3.099-5.092,4.354-7.899c6.904-15.439,6.813-31.954-0.036-46.337c-1.883-8.732-7.586-21.212-23.319-34.889 C608.75,54.152,508.938,36.451,480.045,40.381c-28.893,3.931,26.266,16.086,26.266,16.086l-4.372-0.038 c-84.153-8.922-168.824-10.07-252.833-8.331c-21.066,0.436-42.196,1.127-62.822,4.686c-5.935,1.024-12.317,2.588-15.85,7.375 c-15.683,21.266,48.469,23.344,58.532,22.934c-44.063,5.727-93.023,7.483-134.002,24.512c-5.718,2.376-11.382,5.192-15.69,9.588 s-5.994,10.56-6.144,16.901c-0.397,16.776,26.564,23.005,42.106,27.632c0,0-81.72,54.339-72.089,81.922 c3.981,11.402,9.915,23.405,20.912,35.221c-6.268,7.869-11.787,16.126-16.053,24.856c-2.61,5.34-6.029,12.656-3.108,18.803 c14.884,31.325,240.613,138.856,421.495,108.165c48.051-8.153,95.907-21.635,138.031-45.479 c41.919-23.729,84.636-62.924,95.196-112.348c0.348-1.629,0.603-3.208,0.777-4.744 C706.95,245.345,710.777,215.344,704.185,191.603z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Birds"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M557.959,160.595c0,0,1.02-3.061,6.122-4.082 c5.102-1.02,11.225,4.592,11.225,4.592s4.082-8.163,8.163-8.674c4.082-0.51,8.674,3.061,8.674,3.061"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M544.694,179.983c0,0,1.02-3.061,6.122-4.082 c5.102-1.02,11.225,4.592,11.225,4.592s4.082-8.163,8.163-8.674c4.082-0.51,8.674,3.061,8.674,3.061"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M593.164,180.105c0,0,0.777-2.33,4.66-3.107 c3.884-0.777,8.544,3.495,8.544,3.495s3.107-6.214,6.214-6.602c3.107-0.388,6.602,2.33,6.602,2.33"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M649.858,200.647c0,0,0.509-1.528,3.056-2.038 c2.547-0.509,5.603,2.292,5.603,2.292s2.038-4.075,4.075-4.33c2.037-0.255,4.33,1.528,4.33,1.528"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Clouds"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M378.139,155.188c-5.272-23.687-32.575-41.341-56.374-37.958 c-5.931,0.843-11.702,3.062-16.158,7.162c-6.077,5.591-4.635,11.938-7.644,18.866c-0.835,1.923-2.463,3.631-4.533,3.986 c-5.919,1.015-10.687-4.885-16.68-4.929c-4.481-0.033-10.209,2.443-12.709,6.312c-2.327,3.603-0.705,9.891-4.894,12.283 c-4.685,2.675-10.382-2.414-15.446-0.572c-6.293,2.288-3.432,6.865-5.721,9.725c-2.288,2.86-6.865,1.716-13.158,1.144 c-6.293-0.572-11.441,6.865-11.441,6.865h198.511c0,0,1.716-2.86-5.721-14.302c-7.437-11.442-17.734-3.432-22.311-3.432 C379.287,160.337,378.141,155.197,378.139,155.188z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M433.423,117.144c-2.115-9.503-13.069-16.585-22.617-15.228 c-2.38,0.338-4.695,1.229-6.483,2.873c-2.438,2.243-1.86,4.789-3.067,7.569c-0.335,0.771-0.988,1.456-1.819,1.599 c-2.374,0.407-4.288-1.96-6.692-1.977c-1.798-0.013-4.096,0.98-5.099,2.532c-0.934,1.445-0.283,3.968-1.963,4.928 c-1.879,1.073-4.165-0.968-6.197-0.23c-2.525,0.918-1.377,2.754-2.295,3.902c-0.918,1.148-2.754,0.689-5.279,0.459 c-2.525-0.229-4.59,2.754-4.59,2.754h79.64c0,0,0.688-1.148-2.295-5.738c-2.984-4.59-7.115-1.377-8.951-1.377 C433.884,119.21,433.424,117.148,433.423,117.144z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M603.325,233.601c-2.115-9.503-13.069-16.585-22.617-15.228 c-2.38,0.338-4.695,1.229-6.483,2.874c-2.438,2.243-1.86,4.789-3.067,7.569c-0.335,0.771-0.988,1.456-1.818,1.599 c-2.374,0.407-4.288-1.96-6.692-1.978c-1.798-0.013-4.096,0.98-5.099,2.532c-0.934,1.445-0.283,3.968-1.963,4.928 c-1.879,1.073-4.165-0.968-6.197-0.23c-2.525,0.918-1.377,2.754-2.295,3.902c-0.918,1.148-2.754,0.689-5.279,0.459 c-2.525-0.23-4.59,2.754-4.59,2.754h79.64c0,0,0.689-1.148-2.295-5.738c-2.984-4.59-7.115-1.377-8.951-1.377 C603.786,235.667,603.326,233.605,603.325,233.601z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M475.579,223.202c-3.24-14.555-20.017-25.403-34.641-23.325 c-3.645,0.518-7.191,1.882-9.929,4.401c-3.734,3.436-2.848,7.336-4.697,11.593c-0.513,1.182-1.514,2.231-2.785,2.45 c-3.637,0.624-6.567-3.002-10.25-3.029c-2.754-0.02-6.274,1.501-7.81,3.879c-1.43,2.214-0.433,6.078-3.007,7.548 c-2.879,1.644-6.379-1.483-9.491-0.352c-3.867,1.406-2.109,4.218-3.515,5.976c-1.406,1.758-4.218,1.055-8.085,0.703 c-3.867-0.352-7.031,4.218-7.031,4.218h121.983c0,0,1.055-1.758-3.515-8.788c-4.57-7.031-10.898-2.109-13.71-2.109 C476.284,226.367,475.58,223.208,475.579,223.202z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mountains"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M504.269,390.9c0,0-7.291-7.555-5.245-7.327c2.046,0.227,5.876,5.876,5.876,5.876 s0.053-12.454,1.872-9.725c1.819,2.729-0.416,9.777-0.416,9.777s5.2-8.113,5.189-6.787c-0.036,4.099-4.007,7.306-4.007,7.306 s8.327-6.169,6.963-3.667c-1.364,2.501-6.689,4.865-6.689,4.865s9.599-1.936,6.189-0.572c-3.411,1.364-6.657,2.301-6.657,2.301 h-2.652c0,0-9.065-4.548-5.654-3.866C502.45,389.763,504.269,390.9,504.269,390.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M600.558,367.261c0,0-5.674-5.879-4.082-5.702c1.593,0.177,4.573,4.573,4.573,4.573 s0.041-9.692,1.457-7.568c1.416,2.124-0.324,7.609-0.324,7.609s4.047-6.314,4.038-5.282c-0.028,3.19-3.118,5.685-3.118,5.685 s6.481-4.801,5.419-2.854c-1.062,1.947-5.206,3.786-5.206,3.786s7.471-1.507,4.816-0.445c-2.654,1.062-5.18,1.791-5.18,1.791 h-2.064c0,0-7.054-3.539-4.4-3.008C599.142,366.376,600.558,367.261,600.558,367.261z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M689.953,346.171c0,0-5.674-5.879-4.082-5.702c1.593,0.177,4.573,4.573,4.573,4.573 s0.041-9.692,1.457-7.568c1.416,2.124-0.324,7.609-0.324,7.609s4.047-6.314,4.038-5.282c-0.028,3.19-3.118,5.685-3.118,5.685 s6.48-4.801,5.419-2.854c-1.062,1.947-5.205,3.786-5.205,3.786s7.471-1.507,4.816-0.445c-2.654,1.062-5.18,1.791-5.18,1.791h-2.064 c0,0-7.055-3.539-4.4-3.008C688.538,345.286,689.953,346.171,689.953,346.171z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9"
    },
    d: "M576.022,394.342c0,0-6.778-7.023-4.876-6.812c1.903,0.211,5.463,5.463,5.463,5.463 s0.049-11.577,1.74-9.04c1.691,2.537-0.387,9.089-0.387,9.089s4.835-7.542,4.824-6.31c-0.033,3.811-3.725,6.791-3.725,6.791 s7.741-5.734,6.473-3.409c-1.268,2.325-6.218,4.523-6.218,4.523s8.924-1.8,5.753-0.532c-3.171,1.268-6.188,2.139-6.188,2.139 h-2.466c0,0-8.427-4.228-5.256-3.594C574.331,393.285,576.022,394.342,576.022,394.342z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    points: "441.893,363.875 381.926,296.644 368.793,307.151  303.051,208.17 245.819,220.922 228.705,188.952 212.07,188.076 180.55,125.913 133.404,168.929 110.673,160.811 27.866,245.242  "
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    x1: 453.138,
    y1: 376.482,
    x2: 446.851,
    y2: 369.433
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    x1: 215.088,
    y1: 229.142,
    x2: 210.131,
    y2: 230.484
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    x1: 245.702,
    y1: 220.85,
    x2: 220.669,
    y2: 227.63
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    points: "151.263,192.074 165.28,171.382 164.333,164.284  180.423,131.632  "
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    x1: 145.405,
    y1: 200.721,
    x2: 148.921,
    y2: 195.53
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    x1: 123.654,
    y1: 212.962,
    x2: 100.923,
    y2: 243.784
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    points: "111.806,164.284 117.485,177.061 130.262,187.471  128.842,205.927 125.746,210.125  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    points: "228.705,188.952 216.86,200.248 212.601,193.15  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    points: "707.008,315.436 614.992,250.532 587.058,289.967  552.552,278.465 499.15,353.229 464.643,345.835 447.39,360.623  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    points: "614.992,250.532 604.052,298.624 591.15,292.979  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    points: "552.847,281.287 525.834,359.908 507.287,356.683  "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Trees_2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9"
    },
    d: "M551.599,275.67c-23.946,0-43.357,19.28-43.357,43.062c0,11.026,4.175,21.083,11.037,28.701 c3.14-0.455,8.862-0.768,15.187,1.384c8.381,2.851,13.604,7.523,14.748,8.614h3.885c1.144-1.091,6.367-5.763,14.748-8.614 c6.886-2.343,13.061-1.764,15.962-1.261c6.928-7.632,11.147-17.738,11.147-28.824C594.956,294.949,575.545,275.67,551.599,275.67z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M571.782,336.004c-1.334,0.645-2.656,1.312-3.961,2.008c-1.306,0.714-2.587,1.489-3.788,2.338 c-0.454,0.314-0.897,0.638-1.34,0.962l7.102-13.231l-9.745,15.261c-0.987,0.794-1.958,1.605-2.909,2.432 c-1.574,1.37-3.104,2.766-4.604,4.205l-0.495-14.354l10.196-15.525l-10.271,13.353l-0.443-12.847l-0.733,14.375l-0.002,0.003 l0.002,0.001l-0.734,14.408c-1.302-1.232-2.627-2.437-3.986-3.619c-1.069-0.929-2.157-1.841-3.272-2.727l-9.22-15.746l6.772,13.89 c-0.389-0.283-0.776-0.568-1.172-0.842c-1.201-0.848-2.481-1.624-3.788-2.338c-1.305-0.696-2.627-1.363-3.961-2.008 c-2.672-1.282-5.393-2.481-8.204-3.471c2.731,1.157,5.349,2.513,7.906,3.944c1.276,0.72,2.538,1.46,3.779,2.227 c1.221,0.773,2.396,1.59,3.512,2.492c2.246,1.778,4.345,3.72,6.365,5.724c1.765,1.753,3.482,3.565,5.119,5.405l-0.932,18.287 h4.272l-0.605-17.544c1.83-2.095,3.778-4.16,5.781-6.148c2.02-2.004,4.118-3.945,6.365-5.724c1.116-0.902,2.29-1.72,3.512-2.492 c1.241-0.767,2.502-1.507,3.779-2.227c2.557-1.431,5.175-2.787,7.906-3.944C577.175,333.523,574.453,334.723,571.782,336.004z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9"
    },
    d: "M218.708,334.758c0,12.373-6.938,13.307-15.497,13.307c-8.559,0-15.497-0.934-15.497-13.307 c0-12.373,6.938-38.236,15.497-38.236C211.77,296.521,218.708,322.385,218.708,334.758z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#263238"
    },
    points: "208.451,340.371 205.887,340.548 212.564,336.047 207.796,338.457 208.451,336.574  206.271,339.228 203.714,340.521 203.511,331.636 204.865,328.348 203.478,330.197 203.36,325.045 207.607,319.383  203.331,323.761 203.072,312.422 202.843,319.679 200.119,316.641 202.799,321.074 202.436,332.569 200.065,331.018  197.904,327.188 198.77,330.172 194.529,327.399 202.386,334.175 201.196,371.906 204.431,371.906 203.747,341.991  204.495,341.487  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9"
    },
    d: "M635.517,292.148c0,24.176-13.557,26.002-30.28,26.002c-16.724,0-30.281-1.825-30.281-26.002 s13.557-74.714,30.281-74.714C621.96,217.434,635.517,267.972,635.517,292.148z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.31,
      fill: "#FFFFFF"
    },
    d: "M635.517,292.148c0,24.176-13.557,26.002-30.28,26.002 c-16.724,0-30.281-1.825-30.281-26.002s13.557-74.714,30.281-74.714C621.96,217.434,635.517,267.972,635.517,292.148z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#263238"
    },
    points: "615.475,303.117 610.466,303.462 623.512,294.668 614.195,299.377 615.475,295.698  611.215,300.884 606.219,303.409 605.822,286.048 608.468,279.623 605.758,283.236 605.528,273.17 613.826,262.106  605.471,270.66 604.964,248.504 604.517,262.685 599.194,256.748 604.431,265.409 603.723,287.871 599.088,284.841  594.866,277.356 596.559,283.188 588.271,277.768 603.624,291.01 601.299,364.737 607.62,364.737 606.285,306.282  607.745,305.297  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9"
    },
    d: "M700.336,301.663c0,12.373-6.938,13.307-15.497,13.307c-8.559,0-15.497-0.934-15.497-13.307 c0-12.373,6.938-38.236,15.497-38.236C693.398,263.427,700.336,289.29,700.336,301.663z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    d: "M700.336,301.663c0,12.373-6.938,13.307-15.497,13.307 c-8.559,0-15.497-0.934-15.497-13.307c0-12.373,6.938-38.236,15.497-38.236C693.398,263.427,700.336,289.29,700.336,301.663z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#263238"
    },
    points: "690.079,307.277 687.516,307.454 694.192,302.953 689.424,305.363 690.079,303.48  687.899,306.134 685.342,307.426 685.139,298.542 686.493,295.254 685.106,297.103 684.988,291.951 689.235,286.289  684.959,290.667 684.7,279.328 684.471,286.585 681.747,283.546 684.427,287.979 684.065,299.475 681.693,297.924  679.532,294.093 680.398,297.078 676.157,294.304 684.014,301.081 682.824,338.812 686.059,338.812 685.375,308.897  686.123,308.393  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9"
    },
    d: "M68.666,291.201c0,12.373-6.938,13.307-15.497,13.307s-15.497-0.934-15.497-13.307 c0-12.373,6.938-38.236,15.497-38.236S68.666,278.828,68.666,291.201z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    d: "M68.666,291.201c0,12.373-6.938,13.307-15.497,13.307s-15.497-0.934-15.497-13.307 c0-12.373,6.938-38.236,15.497-38.236S68.666,278.828,68.666,291.201z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#263238"
    },
    points: "58.409,296.815 55.846,296.991 62.522,292.491 57.754,294.901 58.409,293.018  56.229,295.672 53.672,296.964 53.469,288.079 54.823,284.791 53.436,286.64 53.318,281.489 57.565,275.826 53.289,280.204  53.03,268.865 52.801,276.123 50.077,273.084 52.757,277.517 52.395,289.012 50.023,287.462 47.862,283.631 48.728,286.615  44.487,283.842 52.344,290.619 51.154,328.35 54.389,328.35 53.706,298.434 54.453,297.931  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9"
    },
    d: "M145.46,263.142c-23.945,0-43.357,19.28-43.357,43.062c0,11.026,4.175,21.083,11.037,28.701 c3.14-0.455,8.862-0.768,15.187,1.384c8.381,2.851,13.604,7.523,14.748,8.614h3.885c1.144-1.091,6.367-5.763,14.748-8.614 c6.886-2.342,13.061-1.764,15.962-1.261c6.928-7.632,11.147-17.738,11.147-28.824C188.817,282.422,169.405,263.142,145.46,263.142 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.33,
      fill: "#FFFFFF"
    },
    d: "M145.46,263.142c-23.945,0-43.357,19.28-43.357,43.062 c0,11.026,4.175,21.083,11.037,28.701c3.14-0.455,8.862-0.768,15.187,1.384c8.381,2.851,13.604,7.523,14.748,8.614h3.885 c1.144-1.091,6.367-5.763,14.748-8.614c6.886-2.342,13.061-1.764,15.962-1.261c6.928-7.632,11.147-17.738,11.147-28.824 C188.817,282.422,169.405,263.142,145.46,263.142z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M165.642,323.477c-1.334,0.645-2.656,1.312-3.961,2.008c-1.306,0.714-2.587,1.489-3.788,2.338 c-0.454,0.314-0.897,0.638-1.34,0.962l7.102-13.231l-9.745,15.261c-0.987,0.794-1.957,1.605-2.909,2.432 c-1.574,1.37-3.104,2.766-4.604,4.205l-0.495-14.354l10.196-15.525l-10.271,13.353l-0.443-12.847l-0.732,14.375l-0.002,0.003 l0.002,0.001l-0.734,14.408c-1.302-1.232-2.627-2.437-3.986-3.619c-1.069-0.929-2.157-1.841-3.272-2.727l-9.22-15.746l6.772,13.89 c-0.389-0.283-0.775-0.568-1.173-0.842c-1.201-0.848-2.481-1.624-3.788-2.338c-1.305-0.696-2.627-1.363-3.96-2.008 c-2.671-1.282-5.393-2.481-8.204-3.471c2.731,1.157,5.349,2.512,7.906,3.944c1.276,0.72,2.538,1.46,3.779,2.227 c1.221,0.773,2.396,1.59,3.512,2.492c2.246,1.778,4.345,3.72,6.365,5.724c1.765,1.753,3.483,3.566,5.119,5.405l-0.932,18.287 h4.272l-0.605-17.544c1.83-2.095,3.778-4.159,5.781-6.148c2.02-2.004,4.118-3.945,6.365-5.724c1.116-0.902,2.29-1.719,3.512-2.492 c1.241-0.767,2.502-1.507,3.779-2.227c2.558-1.431,5.175-2.787,7.906-3.944C171.035,320.996,168.313,322.195,165.642,323.477z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Text"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M265.837,391.648v-39.676h-51.642V326.57l44.295-104.964h37.787V327.2h16.374v24.772h-16.374 v39.676H265.837z M239.806,327.2h26.031v-72.215L239.806,327.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M373.53,391.739c-10.217,0-18.684-2.099-25.401-6.298c-6.718-4.199-11.756-9.972-15.115-17.32 c-3.359-7.347-5.038-15.849-5.038-25.506v-76.203c0-9.936,1.607-18.648,4.828-26.136c3.218-7.485,8.187-13.33,14.905-17.529 s15.324-6.298,25.821-6.298c10.356,0,18.858,2.099,25.506,6.298c6.646,4.199,11.579,10.044,14.8,17.529 c3.218,7.488,4.828,16.201,4.828,26.136v76.203c0,9.657-1.679,18.159-5.038,25.506c-3.359,7.348-8.398,13.121-15.115,17.32 C391.793,389.64,383.465,391.739,373.53,391.739z M373.53,363.189c3.779,0,6.508-1.188,8.187-3.57 c1.679-2.378,2.798-5.212,3.359-8.502c0.558-3.287,0.84-6.331,0.84-9.132v-74.944c0-3.077-0.246-6.298-0.735-9.657 c-0.492-3.359-1.574-6.262-3.254-8.712c-1.679-2.446-4.48-3.674-8.397-3.674c-3.92,0-6.754,1.227-8.502,3.674 c-1.751,2.45-2.87,5.353-3.359,8.712c-0.492,3.359-0.735,6.58-0.735,9.657v74.944c0,2.801,0.279,5.845,0.84,9.132 c0.558,3.29,1.748,6.124,3.569,8.502C367.16,362.001,369.889,363.189,373.53,363.189z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M487.939,391.648v-39.676h-51.642V326.57l44.295-104.964h37.786V327.2h16.374v24.772h-16.374 v39.676H487.939z M461.908,327.2h26.031v-72.215L461.908,327.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Floor_1_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M720.109,309.639c-65.377,42.858-194.495,72.028-343.098,72.028 c-153.162,0-285.629-30.986-348.938-76.009v172.344h692.036V309.639z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M705.907,318.188c-68.82,38.142-190.397,63.479-328.896,63.479 c-153.162,0-285.629-30.986-348.938-76.009"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M720.412,309.444c-2.947,1.939-6.024,3.851-9.227,5.733"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Trees_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9"
    },
    d: "M678.37,299.652c0,25.28-14.176,27.189-31.664,27.189s-31.664-1.909-31.664-27.189 c0-25.281,14.176-78.126,31.664-78.126S678.37,274.372,678.37,299.652z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#263238"
    },
    points: "657.412,311.123 652.175,311.484 665.817,302.287 656.074,307.212 657.412,303.365  652.958,308.787 647.734,311.428 647.319,293.274 650.085,286.556 647.252,290.334 647.011,279.808 655.688,268.238  646.951,277.183 646.422,254.015 645.954,268.844 640.388,262.635 645.864,271.693 645.123,295.181 640.277,292.012  635.862,284.185 637.633,290.283 628.966,284.616 645.02,298.462 642.589,375.557 649.199,375.557 647.802,314.432  649.329,313.402  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M644.573,376.237c0,0-11.687-12.109-8.406-11.744c3.28,0.365,9.419,9.419,9.419,9.419 s0.085-19.961,3.001-15.587c2.916,4.374-0.667,15.671-0.667,15.671s8.335-13.003,8.317-10.879 c-0.058,6.57-6.422,11.709-6.422,11.709s13.347-9.887,11.16-5.878c-2.187,4.009-10.721,7.798-10.721,7.798 s15.386-3.104,9.919-0.917c-5.467,2.187-10.669,3.688-10.669,3.688h-4.251c0,0-14.529-7.289-9.062-6.196 C641.657,374.415,644.573,376.237,644.573,376.237z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M84.725,361.203c0,0-10.108-10.473-7.271-10.158c2.837,0.315,8.147,8.147,8.147,8.147 s0.073-17.265,2.595-13.482c2.522,3.783-0.577,13.554-0.577,13.554s7.209-11.247,7.193-9.41 c-0.05,5.683-5.555,10.128-5.555,10.128s11.544-8.552,9.653-5.084c-1.891,3.468-9.273,6.745-9.273,6.745s13.308-2.685,8.579-0.793 c-4.729,1.891-9.228,3.19-9.228,3.19h-3.677c0,0-12.567-6.305-7.838-5.359C82.203,359.627,84.725,361.203,84.725,361.203z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9"
    },
    d: "M121.261,285.871c0,25.308-14.192,27.219-31.698,27.219c-17.506,0-31.698-1.911-31.698-27.219 s14.192-78.211,31.698-78.211C107.069,207.66,121.261,260.563,121.261,285.871z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#263238"
    },
    points: "100.281,297.354 95.038,297.715 108.694,288.509 98.941,293.439 100.281,289.587  95.822,295.016 90.591,297.66 90.176,279.486 92.946,272.76 90.109,276.542 89.868,266.005 98.555,254.423 89.808,263.378  89.278,240.184 88.81,255.029 83.238,248.814 88.72,257.881 87.979,281.395 83.127,278.222 78.707,270.387 80.479,276.491  71.804,270.819 87.875,284.68 85.441,361.858 92.059,361.858 90.66,300.667 92.189,299.636  "
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Plants_1_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M195.389,387.514c0,0-10.108-10.473-7.271-10.158c2.837,0.315,8.147,8.147,8.147,8.147 s0.074-17.265,2.595-13.482c2.522,3.783-0.577,13.554-0.577,13.554s7.209-11.247,7.193-9.41c-0.05,5.683-5.555,10.128-5.555,10.128 s11.544-8.552,9.653-5.084c-1.891,3.468-9.273,6.745-9.273,6.745s13.308-2.684,8.579-0.793c-4.729,1.891-9.228,3.19-9.228,3.19 h-3.677c0,0-12.566-6.305-7.838-5.359C192.867,385.937,195.389,387.514,195.389,387.514z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M249.04,410.464c0,0-10.108-10.473-7.271-10.158c2.837,0.315,8.147,8.147,8.147,8.147 s0.073-17.265,2.595-13.482c2.522,3.783-0.577,13.554-0.577,13.554s7.21-11.247,7.193-9.41c-0.05,5.683-5.555,10.128-5.555,10.128 s11.544-8.552,9.653-5.084c-1.891,3.468-9.273,6.745-9.273,6.745s13.308-2.684,8.579-0.793c-4.729,1.892-9.228,3.19-9.228,3.19 h-3.677c0,0-12.567-6.305-7.838-5.359C246.518,408.888,249.04,410.464,249.04,410.464z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M392.943,395.054c0,0-7.291-7.554-5.245-7.327c2.046,0.227,5.876,5.876,5.876,5.876 s0.053-12.453,1.872-9.725c1.819,2.729-0.416,9.777-0.416,9.777s5.201-8.113,5.189-6.787c-0.036,4.099-4.007,7.306-4.007,7.306 s8.327-6.168,6.963-3.667c-1.364,2.501-6.689,4.865-6.689,4.865s9.599-1.936,6.188-0.572c-3.411,1.364-6.656,2.301-6.656,2.301 h-2.652c0,0-9.065-4.548-5.654-3.866C391.124,393.917,392.943,395.054,392.943,395.054z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M675.97,376.978c0,0-5.674-5.879-4.082-5.702s4.573,4.573,4.573,4.573s0.041-9.692,1.457-7.568 s-0.324,7.609-0.324,7.609s4.047-6.314,4.038-5.282c-0.028,3.19-3.118,5.685-3.118,5.685s6.481-4.8,5.419-2.854 c-1.062,1.947-5.206,3.786-5.206,3.786s7.471-1.507,4.816-0.445c-2.654,1.062-5.18,1.791-5.18,1.791h-2.064 c0,0-7.054-3.539-4.4-3.008C674.554,376.093,675.97,376.978,675.97,376.978z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9"
    },
    d: "M293.902,395.094c0,0-10.108-10.473-7.271-10.158c2.837,0.315,8.147,8.147,8.147,8.147 s0.073-17.265,2.595-13.482c2.522,3.783-0.577,13.554-0.577,13.554s7.21-11.247,7.193-9.41c-0.05,5.683-5.555,10.128-5.555,10.128 s11.544-8.552,9.653-5.084c-1.891,3.468-9.273,6.745-9.273,6.745s13.308-2.685,8.579-0.793c-4.729,1.891-9.228,3.19-9.228,3.19 h-3.677c0,0-12.566-6.305-7.838-5.359C291.381,393.518,293.902,395.094,293.902,395.094z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9"
    },
    d: "M220.961,388.136c0,0-6.778-7.023-4.876-6.812c1.902,0.211,5.463,5.463,5.463,5.463 s0.049-11.577,1.74-9.04c1.691,2.537-0.387,9.089-0.387,9.089s4.834-7.542,4.824-6.31c-0.033,3.811-3.725,6.791-3.725,6.791 s7.741-5.734,6.473-3.409c-1.268,2.325-6.218,4.523-6.218,4.523s8.924-1.8,5.753-0.532c-3.171,1.268-6.188,2.139-6.188,2.139 h-2.466c0,0-8.427-4.228-5.256-3.594C219.27,387.079,220.961,388.136,220.961,388.136z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9"
    },
    d: "M136.263,415.877c0,0-6.778-7.023-4.876-6.812c1.903,0.211,5.463,5.463,5.463,5.463 s0.049-11.577,1.74-9.041c1.691,2.537-0.387,9.089-0.387,9.089s4.834-7.542,4.824-6.31c-0.033,3.811-3.725,6.791-3.725,6.791 s7.741-5.734,6.473-3.409c-1.268,2.325-6.218,4.523-6.218,4.523s8.924-1.8,5.753-0.532c-3.171,1.268-6.188,2.139-6.188,2.139 h-2.466c0,0-8.427-4.228-5.256-3.594C134.572,414.82,136.263,415.877,136.263,415.877z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9"
    },
    d: "M363.03,417.237c0,0-6.778-7.023-4.876-6.812c1.902,0.211,5.463,5.463,5.463,5.463 s0.049-11.577,1.74-9.04c1.691,2.537-0.387,9.089-0.387,9.089s4.834-7.542,4.824-6.31c-0.033,3.811-3.725,6.791-3.725,6.791 s7.741-5.734,6.473-3.409c-1.268,2.325-6.218,4.523-6.218,4.523s8.924-1.8,5.753-0.532c-3.171,1.268-6.188,2.139-6.188,2.139 h-2.466c0,0-8.427-4.228-5.256-3.594C361.339,416.18,363.03,417.237,363.03,417.237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9"
    },
    d: "M473.003,417.604c0,0-6.778-7.023-4.876-6.812c1.902,0.211,5.463,5.463,5.463,5.463 s0.049-11.577,1.74-9.04c1.691,2.537-0.387,9.089-0.387,9.089s4.834-7.542,4.824-6.31c-0.033,3.811-3.725,6.791-3.725,6.791 s7.741-5.734,6.473-3.409c-1.268,2.325-6.218,4.523-6.218,4.523s8.924-1.8,5.753-0.532c-3.171,1.268-6.188,2.139-6.188,2.139 h-2.466c0,0-8.427-4.228-5.256-3.594S473.003,417.604,473.003,417.604z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9"
    },
    d: "M677.469,395.635c0,0-10.32-10.693-7.424-10.371c2.897,0.322,8.318,8.318,8.318,8.318 s0.075-17.627,2.65-13.764c2.575,3.862-0.589,13.838-0.589,13.838s7.361-11.482,7.344-9.607c-0.051,5.802-5.671,10.34-5.671,10.34 s11.786-8.731,9.855-5.19c-1.931,3.54-9.467,6.886-9.467,6.886s13.587-2.741,8.759-0.81c-4.828,1.931-9.422,3.257-9.422,3.257 h-3.754c0,0-12.83-6.437-8.002-5.471C674.895,394.026,677.469,395.635,677.469,395.635z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9"
    },
    d: "M62.538,395.635c0,0-10.32-10.693-7.423-10.371c2.897,0.322,8.318,8.318,8.318,8.318 s0.075-17.627,2.65-13.764c2.575,3.862-0.589,13.838-0.589,13.838s7.361-11.482,7.344-9.607c-0.051,5.802-5.671,10.34-5.671,10.34 s11.786-8.731,9.855-5.19c-1.931,3.54-9.467,6.886-9.467,6.886s13.587-2.741,8.759-0.81c-4.828,1.931-9.422,3.257-9.422,3.257 h-3.754c0,0-12.83-6.437-8.002-5.471C59.963,394.026,62.538,395.635,62.538,395.635z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9"
    },
    d: "M113.447,380.537c0,0-10.562-18.213-7.549-19.619c3.012-1.406,9.238,12.452,9.238,12.452 s-1.205-26.108,1.607-23.698c2.812,2.41,5.423,20.886,5.423,20.886s5.623-20.083,7.431-15.866 c1.808,4.217-1.445,16.979-1.445,16.979s8.072-15.372,8.876-10.351c0.803,5.021-3.816,13.255-3.816,13.255 s10.644-10.644,11.447-6.427c0.803,4.217-2.812,8.435-2.812,8.435s14.058-7.632,10.644-3.414c-3.414,4.217-8.435,9.64-8.435,9.64 s13.456-4.82,11.849-2.008c-1.607,2.812-7.632,5.824-7.632,5.824s11.046-2.008,9.841-0.201c-1.205,1.807-4.01,3.582-4.01,3.582 H104.09c0,0-13.255-4.787-8.033-5.189c5.222-0.402,10.041,1.807,10.041,1.807s-16.267-11.046-8.636-11.849 c7.632-0.803,13.857,8.836,13.857,8.836s-10.845-15.263-7.029-12.853L113.447,380.537z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M114.127,385.718c0,0-13.636-14.129-9.809-13.703 s10.99,10.99,10.99,10.99s0.099-23.29,3.501-18.187c3.402,5.103-0.778,18.284-0.778,18.284s9.726-15.172,9.704-12.694 c-0.067,7.666-7.493,13.663-7.493,13.663s15.573-11.536,13.022-6.858c-2.552,4.678-12.509,9.099-12.509,9.099 s17.953-3.621,11.574-1.07c-6.379,2.552-12.449,4.304-12.449,4.304h-4.96c0,0-16.952-8.505-10.573-7.229 C110.725,383.592,114.127,385.718,114.127,385.718z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9"
    },
    d: "M563.203,412.582c0,0-19.962-34.425-14.269-37.082c5.694-2.657,17.461,23.535,17.461,23.535 s-2.278-49.347,3.037-44.792c5.314,4.555,10.249,39.478,10.249,39.478s10.628-37.959,14.045-29.988 c3.416,7.971-2.731,32.092-2.731,32.092s15.258-29.055,16.776-19.565c1.518,9.49-7.212,25.053-7.212,25.053 s20.118-20.118,21.637-12.147c1.518,7.971-5.314,15.943-5.314,15.943s26.571-14.424,20.118-6.453 c-6.453,7.971-15.943,18.22-15.943,18.22s25.433-9.11,22.396-3.796c-3.037,5.314-14.424,11.008-14.424,11.008 s20.878-3.796,18.6-0.379c-2.278,3.416-7.58,6.77-7.58,6.77h-94.531c0,0-25.053-9.048-15.184-9.807 c9.869-0.759,18.979,3.416,18.979,3.416s-30.747-20.878-16.322-22.396c14.424-1.518,26.192,16.702,26.192,16.702 s-20.498-28.849-13.286-24.294L563.203,412.582z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M564.488,422.375c0,0-25.774-26.704-18.54-25.901 s20.772,20.772,20.772,20.772s0.187-44.021,6.618-34.375c6.43,9.646-1.471,34.559-1.471,34.559s18.383-28.677,18.342-23.992 c-0.127,14.49-14.163,25.824-14.163,25.824s29.435-21.805,24.613-12.963c-4.823,8.842-23.644,17.198-23.644,17.198 s33.932-6.845,21.875-2.022c-12.057,4.823-23.53,8.134-23.53,8.134h-9.375c0,0-32.042-16.076-19.985-13.665 C558.058,418.356,564.488,422.375,564.488,422.375z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Rocks"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M147.847,381.569c0,0,2.042-1.846,3.793-1.846 c1.751,0,7.1,2.571,7.1,2.571s2.14,3.296,2.334,3.494c0.195,0.198,2.82,1.319,3.015,1.78c0.195,0.462,0.584,1.978,0.584,1.978 h-16.339l-3.015-7.911L147.847,381.569z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M151.64,379.723l-0.097,1.556c0,0,4.182,2.431,4.085,3.307c-0.097,0.875-0.973,2.918-0.973,2.918 l2.14,2.237h-11.379l0.875-6.711C146.291,383.03,148.722,379.528,151.64,379.723z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M126.548,380.598c0,0,8.17-12.254,10.017-12.449 c1.848-0.194,5.738,1.362,7.197,3.89c1.459,2.529,2.82,7.489,2.918,7.781c0.097,0.292,0.486,0.486,2.723,4.085 c2.237,3.598,2.14,5.641,2.14,5.641h-31.609c0,0,0.681-3.21,1.848-5.057s3.89-2.529,3.89-2.529L126.548,380.598z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M139.094,389.351c0,0-0.875-2.14-0.973-2.431c-0.097-0.292-0.097-3.112-0.389-4.279 c-0.292-1.167-2.723-4.766-2.723-4.766l1.751-5.057l-0.875-0.681l1.459-3.599l-0.817-0.378 c-1.915,0.344-9.979,12.438-9.979,12.438l-0.875,1.362c0,0-2.723,0.681-3.89,2.529c-0.998,1.58-1.639,4.15-1.804,4.863H139.094z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M462.839,384.617c0,0,1.281-1.157,2.378-1.157 c1.098,0,4.452,1.612,4.452,1.612s1.342,2.067,1.464,2.191c0.122,0.124,1.769,0.827,1.89,1.116 c0.122,0.289,0.366,1.24,0.366,1.24h-10.245l-1.89-4.96L462.839,384.617z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M465.218,383.459l-0.061,0.976c0,0,2.622,1.525,2.561,2.073s-0.61,1.829-0.61,1.829l1.342,1.403 h-7.135l0.549-4.208C461.864,385.533,463.388,383.337,465.218,383.459z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M449.485,384.008c0,0,5.122-7.684,6.281-7.805 c1.159-0.122,3.598,0.854,4.513,2.439c0.915,1.585,1.768,4.695,1.829,4.878c0.061,0.183,0.305,0.305,1.707,2.561 c1.403,2.256,1.342,3.537,1.342,3.537h-19.819c0,0,0.427-2.012,1.159-3.171c0.732-1.159,2.439-1.586,2.439-1.586L449.485,384.008 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M457.351,389.496c0,0-0.549-1.342-0.61-1.525c-0.061-0.183-0.061-1.951-0.244-2.683 c-0.183-0.732-1.708-2.988-1.708-2.988l1.098-3.171l-0.549-0.427l0.915-2.256l-0.512-0.237c-1.201,0.216-6.257,7.799-6.257,7.799 l-0.549,0.854c0,0-1.707,0.427-2.439,1.586c-0.626,0.991-1.028,2.602-1.131,3.049H457.351z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M628.223,414.532c0,0,3.86-3.489,7.169-3.489 c3.309,0,13.419,4.86,13.419,4.86s4.044,6.23,4.412,6.604c0.368,0.374,5.331,2.492,5.699,3.364 c0.368,0.872,1.103,3.738,1.103,3.738h-30.883l-5.699-14.953L628.223,414.532z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M635.392,411.043l-0.184,2.941c0,0,7.905,4.596,7.721,6.25c-0.184,1.654-1.838,5.515-1.838,5.515 l4.044,4.228h-21.508l1.654-12.684C625.281,417.293,629.877,410.675,635.392,411.043z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M587.965,412.697c0,0,15.441-23.162,18.934-23.53 c3.493-0.368,10.846,2.574,13.603,7.353c2.757,4.779,5.331,14.155,5.515,14.706c0.184,0.552,0.919,0.919,5.147,7.721 c4.228,6.802,4.044,10.662,4.044,10.662h-59.743c0,0,1.287-6.066,3.493-9.559c2.206-3.493,7.353-4.78,7.353-4.78L587.965,412.697 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M611.678,429.241c0,0-1.654-4.044-1.838-4.596c-0.184-0.552-0.184-5.883-0.735-8.088 c-0.551-2.206-5.147-9.008-5.147-9.008l3.309-9.559l-1.654-1.287l2.757-6.802l-1.544-0.715c-3.62,0.65-18.861,23.51-18.861,23.51 l-1.654,2.574c0,0-5.147,1.287-7.353,4.78c-1.886,2.987-3.097,7.843-3.41,9.191H611.678z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPageNotFound);
export default __webpack_public_path__ + "static/media/pageNotFound.1b1563d1863040c805c75d09a21ae7fd.svg";
export { ForwardRef as ReactComponent };